import {
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import { useResponsive } from 'src/hooks/use-responsive';

type SideMenuProps = {
  activeStep: number;
  steps: string[];
  handleToStep: (step: number) => void;
};

export function SideNavigation({
  activeStep,
  steps,
  handleToStep,
}: SideMenuProps) {
  const mdUp = useResponsive('up', 'md');

  return (
    <Stack sx={{ width: mdUp ? 240 : '100%', flex: 'none' }}>
      <ToggleButtonGroup
        sx={{ position: 'sticky', top: 90 }}
        value={activeStep}
        onChange={(e, value) => handleToStep(value)}
        orientation={mdUp ? 'vertical' : 'horizontal'}
        exclusive
      >
        {steps.map((step, index) => (
          <ToggleButton
            key={index}
            value={index}
            sx={{ justifyContent: 'flex-start' }}
          >
            <Typography variant="inherit" noWrap>
              {step}
            </Typography>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Stack>
  );
}
